import { useQuery } from "@tanstack/react-query"

import staticSiteApi from "./staticSiteApi"

const useAchievementQuery = () => {
  const { data } = useQuery(["staticSiteApi.achievementApi"], staticSiteApi.achievementApi)

  return data
}

export default useAchievementQuery
